import HighlightsImage from "@/components/HighlightsImage.vue";
import { builderCta } from "@/helpers/builder-init/index";
import { useColors } from "@/helpers/composables/useColors";
const { colors } = useColors();
export const highlightImageInit = {
    component: HighlightsImage,
    name: "InteractiveImage",
    models: ["category-landing-content", "campaign-content"],
    inputs: [
        {
            name: "elementId",
            friendlyName: "Element ID",
            type: "string",
            required: true
        },
        {
            name: "bgImage",
            friendlyName: "Background Image",
            type: "file",
            allowedFileTypes: ["jpeg", "png", "svg"]
        },
        {
            name: "bgImageAlt",
            type: "string",
            defaultValue: ""
        },
        {
            name: "image",
            friendlyName: "Image",
            type: "file",
            allowedFileTypes: ["jpeg", "png", "svg"]
        },
        {
            name: "imageAlt",
            friendlyName: "Image Alt",
            type: "string"
        },
        {
            name: "contentPosition",
            friendlyName: "Content Position",
            type: "string",
            enum: ["image-left", "image-right"]
        },
        {
            name: "textProps",
            friendlyName: "Text Properties",
            type: "object",
            subFields: [
                {
                    name: "textPosition",
                    friendlyName: "Text Position",
                    type: "string",
                    enum: ["left", "right", "center"],
                    defaultValue: "center"
                },
                {
                    name: "textAlignment",
                    friendlyName: "Text Alignment",
                    type: "string",
                    enum: ["left", "right", "center"],
                    defaultValue: "center"
                },
                {
                    name: "bgColor",
                    friendlyName: "Background Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "texturedBackground",
                    friendlyName: "Textured Background",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "svg"]
                },
                {
                    name: "textColor",
                    friendlyName: "Text Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "eyeBrowColor",
                    friendlyName: "Eyebrown Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "titleColor",
                    friendlyName: "Title Color",
                    type: "string",
                    enum: Object.keys(colors)
                },
                {
                    name: "eyebrow",
                    friendlyName: "Eyebrow",
                    type: "string"
                },
                {
                    name: "title",
                    friendlyName: "Title",
                    type: "string"
                },
                {
                    name: "description",
                    friendlyName: "Description",
                    type: "richText"
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [...builderCta.subFields]
                }
            ]
        }
    ]
};
